<div class="header">
  <span class="label">{{ label() }}</span>
  <ng-content></ng-content>
  @if (isOverLimit()) {
    <span class="over-limit-badge">Over limit</span>
  }
</div>
@if (currentValue() !== null) {
  <div class="value-structured">
    <span class="value-current">{{ currentValue() }}</span>
    <span class="value-separator"> / </span>
    <span class="value-max">{{ formattedMax() }}</span>
  </div>
} @else {
  <span class="value">{{ value() }}</span>
}
@if (showBar()) {
  <div class="bar">
    <div
      class="bar-fill"
      [class.bar-fill--over]="isOverLimit()"
      [style.width.%]="barPercent()"
    ></div>
  </div>
}
